"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaserCode = exports.AdviceShippingType = exports.PaymentMethodCode = exports.PartnerPaymentTerm = exports.BillingEntityCode = void 0;
var BillingEntityCode;
(function (BillingEntityCode) {
    BillingEntityCode["FORTO_DE"] = "62028a945298c26a2093207a";
    BillingEntityCode["FORTO_VN"] = "62260842c494250b0b4031d5";
    BillingEntityCode["FORTO_ZOEY"] = "62cbc2d0baf5e710d073cbfa";
    BillingEntityCode["FORTO_ES"] = "62cbccdabaf5e710d07876eb";
    BillingEntityCode["FORTO_PL"] = "63074192fd7b889693372447";
    BillingEntityCode["FORTO_NL"] = "633e9aae7ac02ec6a0cfd3c1";
    BillingEntityCode["FORTO_IT"] = "635a4f58952a87dc06b83c94";
    BillingEntityCode["FORTO_CN"] = "63ada704c3aa81526788fa37";
    BillingEntityCode["FORTO_NGB"] = "63ac4e0fbc0229c1dd47f9ca";
    BillingEntityCode["FORTO_TSN"] = "63ac4d9ebc0229c1dd47f9c9";
    BillingEntityCode["FORTO_SZX"] = "63ac4d72bc0229c1dd47f9c8";
    BillingEntityCode["FORTO_SHA"] = "63ac4caebc0229c1dd47f9c7";
})(BillingEntityCode = exports.BillingEntityCode || (exports.BillingEntityCode = {}));
var PartnerPaymentTerm;
(function (PartnerPaymentTerm) {
    PartnerPaymentTerm["0D"] = "0D";
    PartnerPaymentTerm["1D"] = "1D";
    PartnerPaymentTerm["2D"] = "2D";
    PartnerPaymentTerm["3D"] = "3D";
    PartnerPaymentTerm["4D"] = "4D";
    PartnerPaymentTerm["5D"] = "5D";
    PartnerPaymentTerm["6D"] = "6D";
    PartnerPaymentTerm["7D"] = "7D";
    PartnerPaymentTerm["8D"] = "8D";
    PartnerPaymentTerm["9D"] = "9D";
    PartnerPaymentTerm["10D"] = "10D";
    PartnerPaymentTerm["11D"] = "11D";
    PartnerPaymentTerm["12D"] = "12D";
    PartnerPaymentTerm["13D"] = "13D";
    PartnerPaymentTerm["14D"] = "14D";
    PartnerPaymentTerm["15D"] = "15D";
    PartnerPaymentTerm["16D"] = "16D";
    PartnerPaymentTerm["17D"] = "17D";
    PartnerPaymentTerm["18D"] = "18D";
    PartnerPaymentTerm["19D"] = "19D";
    PartnerPaymentTerm["20D"] = "20D";
    PartnerPaymentTerm["21D"] = "21D";
    PartnerPaymentTerm["22D"] = "22D";
    PartnerPaymentTerm["23D"] = "23D";
    PartnerPaymentTerm["24D"] = "24D";
    PartnerPaymentTerm["25D"] = "25D";
    PartnerPaymentTerm["26D"] = "26D";
    PartnerPaymentTerm["27D"] = "27D";
    PartnerPaymentTerm["28D"] = "28D";
    PartnerPaymentTerm["29D"] = "29D";
    PartnerPaymentTerm["30D"] = "30D";
    PartnerPaymentTerm["31D"] = "31D";
    PartnerPaymentTerm["32D"] = "32D";
    PartnerPaymentTerm["33D"] = "33D";
    PartnerPaymentTerm["34D"] = "34D";
    PartnerPaymentTerm["35D"] = "35D";
    PartnerPaymentTerm["36D"] = "36D";
    PartnerPaymentTerm["37D"] = "37D";
    PartnerPaymentTerm["38D"] = "38D";
    PartnerPaymentTerm["39D"] = "39D";
    PartnerPaymentTerm["40D"] = "40D";
    PartnerPaymentTerm["41D"] = "41D";
    PartnerPaymentTerm["42D"] = "42D";
    PartnerPaymentTerm["43D"] = "43D";
    PartnerPaymentTerm["44D"] = "44D";
    PartnerPaymentTerm["45D"] = "45D";
    PartnerPaymentTerm["46D"] = "46D";
    PartnerPaymentTerm["47D"] = "47D";
    PartnerPaymentTerm["48D"] = "48D";
    PartnerPaymentTerm["49D"] = "49D";
    PartnerPaymentTerm["50D"] = "50D";
    PartnerPaymentTerm["51D"] = "51D";
    PartnerPaymentTerm["52D"] = "52D";
    PartnerPaymentTerm["53D"] = "53D";
    PartnerPaymentTerm["54D"] = "54D";
    PartnerPaymentTerm["55D"] = "55D";
    PartnerPaymentTerm["56D"] = "56D";
    PartnerPaymentTerm["57D"] = "57D";
    PartnerPaymentTerm["58D"] = "58D";
    PartnerPaymentTerm["59D"] = "59D";
    PartnerPaymentTerm["60D"] = "60D";
    PartnerPaymentTerm["61D"] = "61D";
    PartnerPaymentTerm["62D"] = "62D";
    PartnerPaymentTerm["63D"] = "63D";
    PartnerPaymentTerm["64D"] = "64D";
    PartnerPaymentTerm["65D"] = "65D";
    PartnerPaymentTerm["66D"] = "66D";
    PartnerPaymentTerm["67D"] = "67D";
    PartnerPaymentTerm["68D"] = "68D";
    PartnerPaymentTerm["69D"] = "69D";
    PartnerPaymentTerm["70D"] = "70D";
    PartnerPaymentTerm["71D"] = "71D";
    PartnerPaymentTerm["72D"] = "72D";
    PartnerPaymentTerm["73D"] = "73D";
    PartnerPaymentTerm["74D"] = "74D";
    PartnerPaymentTerm["75D"] = "75D";
    PartnerPaymentTerm["76D"] = "76D";
    PartnerPaymentTerm["77D"] = "77D";
    PartnerPaymentTerm["78D"] = "78D";
    PartnerPaymentTerm["79D"] = "79D";
    PartnerPaymentTerm["80D"] = "80D";
    PartnerPaymentTerm["81D"] = "81D";
    PartnerPaymentTerm["82D"] = "82D";
    PartnerPaymentTerm["83D"] = "83D";
    PartnerPaymentTerm["84D"] = "84D";
    PartnerPaymentTerm["85D"] = "85D";
    PartnerPaymentTerm["86D"] = "86D";
    PartnerPaymentTerm["87D"] = "87D";
    PartnerPaymentTerm["88D"] = "88D";
    PartnerPaymentTerm["89D"] = "89D";
    PartnerPaymentTerm["90D"] = "90D";
    PartnerPaymentTerm["10FM"] = "10FM";
    PartnerPaymentTerm["15CM"] = "15CM";
    PartnerPaymentTerm["15FM"] = "15FM";
    PartnerPaymentTerm["20CM"] = "20CM";
    PartnerPaymentTerm["20FM"] = "20FM";
    PartnerPaymentTerm["23CM"] = "23CM";
    PartnerPaymentTerm["25CM"] = "25CM";
    PartnerPaymentTerm["25FM"] = "25FM";
    PartnerPaymentTerm["BI_W"] = "BI_W";
    PartnerPaymentTerm["CM"] = "CM";
    PartnerPaymentTerm["COD"] = "COD";
    PartnerPaymentTerm["D20"] = "D20";
    PartnerPaymentTerm["D5"] = "D5";
    PartnerPaymentTerm["EFM"] = "EFM";
})(PartnerPaymentTerm = exports.PartnerPaymentTerm || (exports.PartnerPaymentTerm = {}));
var PaymentMethodCode;
(function (PaymentMethodCode) {
    PaymentMethodCode["BANK"] = "BANK";
    PaymentMethodCode["CASH"] = "CASH";
    PaymentMethodCode["CUSTOMS"] = "CUSTOMS";
    PaymentMethodCode["DTAZV_COGS"] = "DTAZV_COGS";
    PaymentMethodCode["DTAZV_CUST"] = "DTAZV_CUST";
    PaymentMethodCode["ISO_PMT"] = "ISO_PMT";
    PaymentMethodCode["SAN_EUR"] = "SAN_EUR";
    PaymentMethodCode["SAN_PLN"] = "SAN_PLN";
    PaymentMethodCode["SAN_USD"] = "SAN_USD";
    PaymentMethodCode["SEPA_COGS"] = "SEPA_COGS";
    PaymentMethodCode["SEPA_CUST"] = "SEPA_CUST";
    PaymentMethodCode["STANDING_ORDER"] = "STANDING_ORDER";
    PaymentMethodCode["WIRE"] = "WIRE";
})(PaymentMethodCode = exports.PaymentMethodCode || (exports.PaymentMethodCode = {}));
var AdviceShippingType;
(function (AdviceShippingType) {
    AdviceShippingType["EMAIL"] = "EMAIL";
    AdviceShippingType["FAX"] = "FAX";
    AdviceShippingType["LETTER"] = "LETTER";
})(AdviceShippingType = exports.AdviceShippingType || (exports.AdviceShippingType = {}));
var PurchaserCode;
(function (PurchaserCode) {
    PurchaserCode["COGS"] = "COGS";
    PurchaserCode["CUSTOMS"] = "CUSTOMS";
    PurchaserCode["COGS_CUSTOMS"] = "COGS_CUSTOMS";
})(PurchaserCode = exports.PurchaserCode || (exports.PurchaserCode = {}));
//# sourceMappingURL=data:application/json;base64,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